import { FormattedMessage } from 'react-intl';

import { Button } from '@xing-com/button';
import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { useSearchParameter } from '@xing-com/crate-hooks-use-search-parameter';
import {
  SEARCH_ALERTS_MODAL_PARAM,
  SEARCH_ALERTS_MODAL_TYPES,
} from '@xing-com/crate-jobs-constants';
import { useToggleSearchAlert } from '@xing-com/crate-jobs-hooks';
import { IconNotificationCenter } from '@xing-com/icons';
import { Toggle } from '@xing-com/toggle';

import { SEARCH_ALERT_LABEL_ID } from '../constants';

export const SearchAlertBannerAction: React.FC = () => {
  const { setSearchParameter } = useSearchParameter();
  const { isLoggedIn } = useLoginState();
  const { isAlertActive, isEditMode, isLoading, onToggleAlert } =
    useToggleSearchAlert();

  const handleOnToggle = (): void => {
    const PropActionOrigin = isAlertActive
      ? 'jobs_toggel_off'
      : 'jobs_toggel_on';
    onToggleAlert({ PropTrackActionData: { PropActionOrigin } });
  };

  const handleOnOpenDialog = (): void => {
    setSearchParameter(
      SEARCH_ALERTS_MODAL_PARAM,
      SEARCH_ALERTS_MODAL_TYPES.CREATE
    );
  };

  if (isEditMode && !isAlertActive) {
    return (
      <Button variant="secondary" size="small" onClick={handleOnToggle}>
        <FormattedMessage id="JOBS_SEARCH_EDIT_ALERT_BANNER_SAVE_BUTTON" />
      </Button>
    );
  }

  return isLoggedIn ? (
    <Toggle
      on={isAlertActive}
      disabled={isLoading}
      onChange={handleOnToggle}
      id={SEARCH_ALERT_LABEL_ID}
      role="button"
      aria-pressed={isAlertActive}
    />
  ) : (
    <Button
      variant="primary"
      icon={IconNotificationCenter}
      onClick={handleOnOpenDialog}
    >
      <FormattedMessage id="JOBS_SEARCH_ALERT_LO_BANNER_ACTIVATE" />
    </Button>
  );
};
